import React from 'react';
import TranslationService from "../../service/TranslationService";
import {TARIFF_MODEL, TARIFF_TYPE, CHOOSE} from "../../language-content/keys";

const tariffTypesLandingMobile = (props) => {
    return (
        <div className="d-block d-md-none">
            <h5 className="serif-bold text-left">{TranslationService.translate(TARIFF_TYPE, props.lang)}</h5>
            <select className="form-control rounded-0 mb-3"
                    disabled={!props.selectedCity || !props.selectedMunicipality}
                    onChange={(e) => props.selectTariffType(e.target.value)}>
                <option selected value={null}>{TranslationService.translate(CHOOSE, props.lang)}</option>
                {props.selectedCity && props.selectedMunicipality && props.tariffTypes.map(tt => {
                    return (<option key={`tt-${tt.tariffType.id}`}
                                    value={tt.tariffType.id}> {tt.tariffType.name} </option>);
                })}
            </select>

            <h5 className="serif-bold text-left">{TranslationService.translate(TARIFF_MODEL, props.lang)}</h5>

            <select className="form-control rounded-0 mb-3"
                    disabled={!props.selectedTariffType || !props.selectedCity || !props.selectedMunicipality}
                    onChange={(e) => props.selectTariffModel(e.target.value)}>
                <option selected>{TranslationService.translate(CHOOSE, props.lang)}</option>
                {props.selectedCity && props.selectedMunicipality && props.tariffModels.map(tm => {
                    return (<option key={`tm-${tm.id}`} value={tm.id}>
                        {props.tariffModelShortNames && props.tariffModelShortNames[tm.id] ? props.tariffModelShortNames[tm.id] : tm.name}
                    </option>);
                })}
            </select>

        </div>
    )
};

export default tariffTypesLandingMobile;
